const e="Refresh token does not exist or has expired";export{e as REFRESH_TOKEN_DOES_NOT_EXIST_OR_HAS_EXPIRED};
//# sourceMappingURL=useRefreshToken.constants.js.map
